import React from 'react';
import './DialogStyles.css';

interface ErrorModalProps {
  isOpen: boolean;
  message: string;
  onClose: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ isOpen, message, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="success-failure-overlay" onClick={onClose}>
      <div className="dialog error" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-icon">⚠️</div>
        <div className="dialog-message">{message}</div>
        <button className="dialog-button" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
};

export default ErrorModal;
